import React, { useEffect, useState } from 'react';
import { DjangoListResponse, User } from 'v2/models';
import { getUserFullName } from 'v2/utils';
import restFactory from 'v2/utils/restFactory';
import FilterDropdown, { SelectOption } from './FilterDropdown';

export interface OwnersSelectProps {
  owner?: User;
  onChange?: (option: User | undefined) => void;
}

function OwnersSelect({ owner, onChange }: OwnersSelectProps) {
  const [defaultOptions, setDefaultOptions] = useState<SelectOption<User>[]>(
    []
  );

  useEffect(() => {
    loadOptions('', (options) => setDefaultOptions(options));
  }, []);

  const loadOptions = (
    inputValue: string,
    callback: (options: SelectOption<User>[]) => void
  ) => {
    const params: { search?: string; size?: number; active: boolean } = {
      active: true,
    };
    if (inputValue) {
      params['search'] = inputValue;
    } else {
      params['size'] = 100;
    }
    restFactory
      .get<DjangoListResponse<User>>(`/dj/api/v1/strapi_user/`, params)
      .then((data) => {
        const options: SelectOption<User>[] = data.results.map((user) => ({
          label: getUserFullName(user),
          value: user,
        }));
        callback(options);
      })
      .catch(() => {
        callback([]);
      });
  };

  return (
    <FilterDropdown
      defaultValue={
        owner ? { label: getUserFullName(owner), value: owner } : null
      }
      loadOptions={loadOptions}
      defaultOptions={defaultOptions}
      onChange={onChange}
    />
  );
}

export default OwnersSelect;
